import {PageTitle} from '../../../_metronic/layout/core';
import {useIntl} from 'react-intl';
import Domaine from '../Components/Domaine';
import {useQuery} from 'react-query';
import {ListService} from '../Types/service';
import {getServicesByClient} from '../Api/api';

const DomainePage = (): JSX.Element => {
  const intl = useIntl();
  const {isLoading, data: services} = useQuery<ListService[]>(
    ['get-service-by-client-domaine'],
    () => getServicesByClient('DOMAIN')
  );

  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.CLOUD.GROUP_DNS'})}</PageTitle>
      <Domaine isLoading={isLoading} services={services} />
    </>
  );
};

export default DomainePage;
